/** Owner "Wash Tiers & Upsells" (1.4 P15). Thin wrapper around the shared WashTiersScreen. */
import React from 'react';
import { api, apiGet, apiPost, apiPatch, apiDelete } from '../../../src/api/client';
import WashTiersScreen from '../../../src/screens/WashTiersScreen';
import type { TierApiClient } from '../../../src/screens/FleetTiersScreen';

const ownerClient: TierApiClient & { put: <T = unknown>(url: string, body?: unknown) => Promise<T> } = {
  get: apiGet, post: apiPost, patch: apiPatch, delete: apiDelete,
  put: (url, body) => api(url, { method: 'PUT', body }),
};

export default function OwnerWashesUpsellsScreen() {
  return <WashTiersScreen client={ownerClient} showVacuumFields />;
}
